<template>
<div class="maxContainer">
  <div class="container">
    <img class="conBac" src="../assets/write_bac.png"/>
    <div class="mainContainer" v-for="(chooseItem, chooseIndex) in choosed" :key="chooseIndex">
      <div class="maintext">「{{ chooseItem }}」</div>
      <div class="optContainer">
        <div class="mainTitle">积极影响</div>
        <div class="radioItem" v-for="(item, index) in options" :key="index">
          <input :name="'options'+chooseIndex" type="radio" :value="index+1" @click="clickRadio"/>
          <span :style="{backgroundImage:'url(' + item + ')'}"></span>
        </div>
      </div>
      <div class="optContainer redioNeg">
        <div class="mainTitle">消极影响</div>
        <div class="radioItem" v-for="(item, index) in optionsNeg" :key="index">
          <input :name="'options'+chooseIndex" type="radio" :value="-index-1" @click="clickRadio"/>
          <span :style="{backgroundImage:'url(' + item + ')'}"></span>
        </div>
      </div>
    </div>
    <button class="confirmBtn" @click="confirm"></button>
    <img class="goDown" src="../assets/go_down.gif"/>
  </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      text: [],
      options: [
        require('../assets/select_num/num1.png'),
        require('../assets/select_num/num2.png'),
        require('../assets/select_num/num3.png'),
        require('../assets/select_num/num4.png'),
        require('../assets/select_num/num5.png'),
      ],
      optionsNeg: [
        require('../assets/select_num/num-1.png'),
        require('../assets/select_num/num-2.png'),
        require('../assets/select_num/num-3.png'),
        require('../assets/select_num/num-4.png'),
        require('../assets/select_num/num-5.png'),
      ],
      choosed: [],
      results: [],
      num: 0,
      optNum: [0,0,0,1,0,0,0]
    }
  },
  mounted () {
    this.choosed = this.$store.getters.getChoosed;
    this.results = this.$store.getters.getResults;
  },
  methods: {
    clickRadio (e) {
      let name = e.currentTarget.name;
      let index = name.slice(name.length-1);
      let text = this.choosed[index];
      if(index > 2) {
        this.results[++index] = {
          text: text,
          score: e.currentTarget.value
        }
      }
      else{
        this.results[index] = {
          text: text,
          score: e.currentTarget.value
        }
      }
      this.optNum[index]++
    },
    confirm () {
      for(let i = 0; i<this.optNum.length; i++){
        if(this.optNum[i] === 0) return
      }
      if(this.results.length === 7){
        this.$store.commit('setResults', this.results);
        this.$router.replace({path:'/inputname'})
      }
    }
  }
}
</script>
<style scoped>
.maxContainer{
  width: 100%;
  background: #faeae7;
}
.container{
  width: 7.5rem;
  background: #faeae7;
  padding: 0 0 2rem;
  box-sizing: border-box;
  letter-spacing: 0.05rem;
  margin: 0 auto;
  position: relative;
}
.conBac{
  width: 7.5rem;
  height: 6.42rem;
}
.mainContainer{
  padding-top: 0.45rem;
}
.maintext{
  font-size: 0.42rem;
  line-height: 0.55rem;
  height: 0.55rem;
  width: 100%;
  margin: 0.2rem auto 0.45rem;
  text-align: center;
}
.mainTitle{
  font-size: 0.33rem;
  line-height: 0.55rem;
  text-align: left;
  width: 5.2rem;
  height: 0.9rem;
  margin: 0 auto;
}
.mainTitle::after{
  content: '/';
  font-size: 0.16rem;
}
.optContainer{
  width: 5.2rem;
  font-size: 0.33rem;
  margin: 0.45rem auto 0;
}
.radioItem{
  display: inline-block;
  width: 0.62rem;
  height: 0.62rem;
  text-align: left;
  overflow: hidden;
  position: relative;
  margin-right: 0.42rem;
}
input[type="radio"]{
  appearance: none;
  width: 0.62rem;
  height: 0.62rem;
  margin: 0;
  position: absolute;
  top: 0;
  left: 0;
  outline: none;
  border: none;
}
input[type="radio"] + span{
  border-radius: 50%;
  background-color: #faeae7;
  display: block;
  width: 0.62rem;
  height: 0.62rem;
  line-height: 0.62rem;
  text-align: center;
  background-size: 100% 100%;
}
input[type="radio"]:checked{
  background-color: transparent;
}
input[type="radio"]:checked + span{
  background: url(../assets/smile.png) no-repeat !important;
  background-size: 100% 100%  !important;
  color: transparent  !important;
}
.redioNeg input[type="radio"]:checked + span{
  background: url(../assets/sad.png) no-repeat  !important;
  background-size: 100% 100%  !important;
  color: transparent  !important;
}
.confirmBtn{
  appearance: none;
  width: 3.26rem;
  height: 0.91rem;
  background: url(../assets/confirm_btn.png) no-repeat;
  background-size: 100% 100%;
  display: block;
  margin: 1rem auto 0;
  padding: 0;
  outline: none;
  border: none;
  position: relative;
}
.confirmBtn::after{
  content: '';
  width: 0.72rem;
  height: 0.25rem;
  position: absolute;
  top: 0.15rem;
  left: -0.36rem;
  background: url(../assets/confirm_btn_left.png) no-repeat;
  background-size: 100% 100%;
}
.goDown{
  position: fixed;
  left: 50%;
  bottom: 2rem;
  width: 0.62rem;
  height: 0.46rem;
  transform: translateX(3rem) rotate(90deg);
}
</style>

